import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ShapeTypes } from '@app/pipelines/models/shape';
import { ShapesService } from '@app/pipelines/services/shapes.service';
import { ClarityService } from '@services/clarity.service';
import { SortPipeModule } from '../../../../pipes/sort.pipe';
import { FieldViewControlService } from '../../services/field-view-control.service';

@Component({
  selector: 'app-events-panel',
  templateUrl: './events-panel.component.html',
  styleUrls: ['./events-panel.component.scss'],
  imports: [
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    TitleCasePipe,
    SortPipeModule,
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventsPanelComponent {
  private readonly shapesService = inject(ShapesService);
  private readonly fieldViewControlService = inject(FieldViewControlService);
  private readonly clarityService = inject(ClarityService);

  readonly eventShapesVisibilitySignal = this.fieldViewControlService.eventShapesVisibility;
  readonly shapes$ = this.shapesService.getAll();

  constructor() {
    this.clarityService.initializeClarity();
  }

  updateEventTypeShapes(value: boolean): void {
    this.clarityService.clarityEvent(`field-view:show-event-types-check-${value}`);
    this.fieldViewControlService.setEventShapesVisibility(value);
  }

  concatShapes(shapeType: ShapeTypes): string {
    return shapeType.replace(/\s/g, '');
  }
}
